import React, { useEffect, useState } from 'react';
import Spinner from '../layouts/Spinner';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { formattedDate } from '../../Utils/Common';
import { useHistory, useLocation } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Show, useAccess } from 'react-redux-permission';
import { Link } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import {
    handleHover,
    setMUIPage,
    updateMUISetting,
} from '../../redux/actions/helper/helper.actions';
import ReportList from './Report.list';
import Downloads from './Downloads';

function Reports(muiPage) {
    let params = new URLSearchParams(useLocation().search);
    const [selectedTab, SetSelectedTab] = useState('Reports');
    const [tabs, setTabs] = useState([
        {
            key: 'Reports',
            class: 'nav-link inv-top-nav inv-top-nav-active',
            _status: 1,
            permission: 'inv.inventory.reports.view',
        },
        {
            key: 'Downloads',
            class: 'nav-link inv-top-nav',
            _status: 0,
            permission: 'inv.inventory.reports.downloads',
        },
    ]);

    function handleChangeTab(tab) {
        setMUIPage(1);
        SetSelectedTab(tab);
        tabs.map((list) => {
            list.class =
                list.key == tab
                    ? 'nav-link inv-top-nav inv-top-nav-active'
                    : 'nav-link inv-top-nav';

            return list;
        });
        setTabs(tabs);
    }

    useEffect(() => {
        let tab = params.get('mode');

        if (tab) {
            handleChangeTab(tab);
            setMUIPage(muiPage);
        }
    }, []);
    return (
        <div className="app-content content">
            <ReactTooltip effect="solid" event="click" />
            <div className="content-wrapper max-1920 mx-auto">
                <div className="content-wrapper-before"></div>
                <div className="content-header row">
                    <div className="content-header-left col-md-12 col-12 mb-2 breadcrumb-new fix-header">
                        <h3 className="content-header-title mb-0 d-inline-block">
                            Inventory{' '}
                        </h3>

                        <div className="breadcrumbs-top d-inline-block">
                            <div className="breadcrumb-wrapper mr-1">
                                <ol className="breadcrumb f-regular">
                                    <li className="breadcrumb-item ">
                                        <a href="#" className="text-white">
                                            Products
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <section className="row f-regular">
                        <div className="col-sm-12">
                            <div className="card">
                                {/* <div className="card-header"></div> */}
                                <div className="card-content collapse show">
                                    <div className="card-body">
                                        <div className="">
                                            <nav class="nav f-regular nav-product-inv">
                                                {tabs.map((item) => (
                                                    <Show
                                                        when={item.permission}
                                                    >
                                                        <a
                                                            onClick={() =>
                                                                handleChangeTab(
                                                                    item.key
                                                                )
                                                            }
                                                            class={item.class}
                                                        >
                                                            {item.key}
                                                        </a>
                                                    </Show>
                                                ))}
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="row f-regular">
                        {(() => {
                            switch (selectedTab) {
                                case 'Reports':
                                    return <ReportList />;
                                case 'Downloads':
                                    return <Downloads />;
                                default:
                                    return null;
                            }
                        })()}
                    </section>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    // reports: state.reports,
    muiPage: state.helper.muiPage,
});

export default connect(mapStateToProps, {})(Reports);
